import { formatDate } from "./dateUtils";

export const isStopSuspended = (suspendedFrom: string | null) => {
  if (!suspendedFrom) return false;
  const nowDate = new Date();
  const suspendedFromDate = new Date(suspendedFrom);
  return nowDate > suspendedFromDate ? "aktuell" : "zukünftig";
};

export const getSuspendedWarning = (
  suspendedFrom: string | null,
  suspendedTo: string | null,
) => {
  if (!suspendedFrom) return "";
  if (!suspendedTo)
    return (
      "Diese Haltestelle wird vom " +
      formatDate(suspendedFrom) +
      " bis auf Weiteres nicht bedient."
    );
  return (
    "Diese Haltestelle wird vom " +
    formatDate(suspendedFrom) +
    " bis zum " +
    formatDate(suspendedTo) +
    " nicht bedient."
  );
};

export const getShortAdress = (properties: any): string => {
  const textElements: string[] = [];
  if (properties.name) textElements.push(properties.name);
  if (properties.street && properties.housenumber) {
    textElements.push(`${properties.street} ${properties.housenumber}`);
  } else if (properties.street) {
    textElements.push(properties.street);
  }
  if (properties.suburb) textElements.push(properties.suburb);
  if (properties.city) textElements.push(properties.city);
  return textElements.join(", ");
};
